<template>
  <div class="va-row">
    <div class="flex xs2 md2">
      <vuestic-simple-select ref="selInput"
        v-model="singleSelOption"
        option-key="keyName"
        :readonly="true"
        v-bind:options="selOptions"
      />
    </div>
    <div class="flex xs2 md2">
      <button class="btn btn-primary btn-sm" @click="getData">
        {{ $t('buttons.search') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    
  },
  data () {
    return {
      singleSelOption: {
        id: 1,
        keyName: 'ALL',
      },
      selOptions: [
        {
          id: 1,
          keyName: 'ALL',
        },
        {
          id: 2,
          keyName: 'PayingOut',
        },
        {
          id: 3,
          keyName: 'PaidOut',
        },
      ],
    }
  },
  methods: {
    getData() {
      alert(this.singleSelOption.keyName);
    },
    init () {
      if (this.$refs.selInput) { 
        this.$refs.selInput.$el.getElementsByTagName('input')[0].readOnly = true
        this.$refs.selInput.$el.getElementsByTagName('input')[0].value = "ALL";
      }
    },
  },
  mounted() {
    this.init();
  },
}
</script>

<style lang="scss" scoped>

</style>
